import { render, staticRenderFns } from "./OVDetail.vue?vue&type=template&id=6e942d36&scoped=true&lang=pug"
import script from "./OVDetail.vue?vue&type=script&lang=js"
export * from "./OVDetail.vue?vue&type=script&lang=js"
import style0 from "./OVDetail.vue?vue&type=style&index=0&id=6e942d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e942d36",
  null
  
)

export default component.exports